import React, { useState, useEffect} from 'react'
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { useSelector } from "react-redux";
import { getWhatsAppUsers } from "../services/urls";
import API from "../services/apiMiddleware";
import Filter from "../components/Filter";
import nodata from "../assets/images/nodata.png";
import Loader from "../components/Loader";


const UserInfoPage = () => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isPayload, setIsPayload] = useState({});
    const [whatsappUserData, setWhatsappUserData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [dataFromChild, setDataFromChild] = useState("");

    const globalFilters = useSelector(
      (state) => state.filterPayload.globalFilters
    );
    const communityId = useSelector((state) => state.communityData.communityId);
    const headers = [
      "User ID",
      "Onbarding Time",
      "Channel Type",
      "Phone Number",
    ];
    const downloadCSV =() => {
        const csvRows = [
          headers.join(","), // Header row
          ...rows.map((row) =>
            [
              row.userId,
              row.onboardingTime,
              row.channelType,
              `"\t${row.phoneNumber}"`, // properly formatted phone number
            ].join(",")
          ),
        ];
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "User_Info.csv";
        a.click();
        window.URL.revokeObjectURL(url);
        setDataFromChild(false);
      }

    useEffect(() => {
      if (globalFilters != null) {
        fetchWhatsappUserData(globalFilters);
      } else {
        fetchWhatsappUserData(globalFilters);
      }
      let requestBody = {
        communityId,
      };

      if (globalFilters != null) {
        requestBody = { ...requestBody, globalFilters };
      }
      setIsPayload(requestBody);
    }, [globalFilters]);

    useEffect(() => {
      if(dataFromChild){        
        downloadCSV();     
      }
      
    }, [dataFromChild]);

    const fetchWhatsappUserData = async (filterPayload) => {
      setIsLoading(true);

      let requestBody = { communityId };

      if (filterPayload && Object.keys(filterPayload).length > 0) {
        requestBody.globalFilters = filterPayload;
      }

      try {
        const { data } = await API.post(getWhatsAppUsers, requestBody);
        const getWhatsappUserData = data.data;
        setWhatsappUserData(getWhatsappUserData);
      } catch (error) {
        console.error("Error fetching user counters data:", error);
      } finally {
        setIsLoading(false); 
      }
    };

     const columns = [
      { id: "userId", label: "User ID", minWidth: 100, align: "center" },
      { id: "onboardingTime", label: "Onboarding Time", minWidth: 100 , align: "center"},
      {
        id: "channelType",
        label: "Channel Type",
        minWidth: 100,
        align: "center",
      },
      {
        id: "phoneNumber",
        label: "Phone Number",
        minWidth: 100,
        align: "center",
      },
    ];

    function createData(userId, onboardingTime, channelType, phoneNumber) {
      return { userId, onboardingTime, channelType, phoneNumber };
    }

   const rows = whatsappUserData.map((item) => {
     return createData(
       item.id, // userId
       item.createdDate, // onboardingTime
       item.channel, // channelType
       item.phoneNo // phoneNumber
     );
   });

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

    const handleDataFromChild = (data) => {
      setDataFromChild(data);
    };

    return (
      <>
        <div className="filterUserInfo">
          <hr class="divider" />
          <Filter sendDataToParent={handleDataFromChild} />
          <hr class="divider" />
        </div>

        {isLoading ? (
          <div>
            <Loader />
          </div>
        ) : whatsappUserData && whatsappUserData.length > 0 ? (
          <div className="userInfoContainer">
            <Paper sx={{ width: "95%", overflow: "hidden" , zIndex: 1}}>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#4ba2e0ff" }}>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.userId}
                          >
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        ) : (
          <div className="nodatadiv">
            <img className="nodata" src={nodata} alt="nodata" />
            <p className="surveyHeaderError">No data available</p>
          </div>
        )}
      </>
    );
}

export default UserInfoPage